import ArrowButton from 'components/ArrowButton';
import clsx from 'clsx';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './styles.scss';
import { Typography, useTheme } from '@mui/material';
import backgroundImage from 'images/backgrounds/q-pattern.svg';
import useSalesforceLogin from 'hooks/useSalesforceLogin';
import MUILink from '@mui/material/Link';

interface Props {
  heading?: string;
  title?: string;
  redirectUrl?: string;
  buttonLabel?: string;
  fullScreen?: boolean;
  md?: boolean;
}

const NotFound: React.FC<React.PropsWithChildren<Props>> = ({
  heading,
  title,
  redirectUrl,
  buttonLabel,
  fullScreen,
  md,
}) => {
  const theme = useTheme();
  const backgroundColor = theme.palette.background.default;
  const { onLogin } = useSalesforceLogin();
  const location = useLocation();

  return (
    <div
      style={{ backgroundColor }}
      className={clsx('not-found', { 'full-screen': fullScreen, 'mid-size': md })}
    >
      <div className="not-found-mask" style={{ backgroundImage: `url("${backgroundImage}")` }} />
      <div className="content">
        <Typography variant="h1" color="textPrimary">
          {heading || 'Oops...'}
        </Typography>
        <Typography variant="h3" color="textPrimary">
          {title || 'You need to login to see this page'}
        </Typography>
        <ArrowButton onClick={onLogin} paper sx={{ mt: 2 }}>
          Click here to login
        </ArrowButton>
        <Typography
          variant="subtitle1"
          color="textPrimary"
          sx={{ textAlign: 'center', mb: 2, mt: 2 }}
        >
          or you can also
        </Typography>
        <ArrowButton component={Link} to={redirectUrl || '/'} paper>
          {buttonLabel || 'Go back home'}
        </ArrowButton>
        <Typography variant="body1" color="textPrimary" sx={{ mt: 4 }}>
          for MerQube Employees,{' '}
          <MUILink color="secondary" component={Link} to={`/login?next=${location.pathname}`}>
            click here
          </MUILink>
        </Typography>
      </div>
    </div>
  );
};

export default NotFound;
